const MIGRATION_HINT =
    'Ejecuta en la BD del backend: database/migrations/20260524_proveedores.sql y database/migrations/20260525_proveedor_inventario.sql, luego reinicia el servidor.';

/** 500 al cargar detalle de inventario con join de catálogo proveedor (p. ej. unidad_medida). */
export const isInventoryCatalogSchemaError = error => {
    const data = error?.response?.data;
    const msg =
        (typeof data === 'string' ? data : '') ||
        (data && typeof data === 'object' ? data.error || data.message : '') ||
        '';

    return /proveedorinventario|proveedores_catalogo|unidad_medida does not exist/i.test(String(msg));
};

/** 500 por columnas proveedor_id / tablas de proveedores sin migrar. */
export const isProveedoresSchemaMigrationError = error => {
    const data = error?.response?.data;
    const msg =
        (typeof data === 'string' ? data : '') ||
        (data && typeof data === 'object' ? data.error || data.message : '') ||
        '';

    return /proveedor_id does not exist/i.test(String(msg));
};

const getRequestUrl = error => String(error?.config?.url || '');

/** Peticiones del módulo de proveedores/inventario (mensajes de migración solo aplican aquí). */
export const isProveedoresRelatedRequest = error => {
    const url = getRequestUrl(error).toLowerCase();
    return /proveedor|supplier/i.test(url);
};

/** 404 de Express cuando la ruta no existe en el backend (HTML "Cannot GET /api/..."). */
export const isApiRouteNotFound = error => {
    if (error?.response?.status !== 404) {
        return false;
    }

    const data = error?.response?.data;

    if (typeof data === 'string' && /cannot\s+(get|post|patch|put|delete)/i.test(data)) {
        return true;
    }

    if (data && typeof data === 'object' && typeof data.error === 'string') {
        return /no encontrado/i.test(data.error);
    }

    return false;
};

/**
 * Mensaje legible desde respuestas del API (error, message o texto plano).
 */
export const getApiErrorMessage = (error, fallback = 'Error de servidor') => {
    if (isApiRouteNotFound(error)) {
        if (isProveedoresRelatedRequest(error)) {
            return `El API de proveedores no está disponible en el servidor. ${MIGRATION_HINT}`;
        }

        return fallback;
    }

    if (isProveedoresSchemaMigrationError(error) || isInventoryCatalogSchemaError(error)) {
        return `La base de datos no tiene las migraciones de proveedores aplicadas. ${MIGRATION_HINT}`;
    }

    const data = error?.response?.data;

    if (typeof data === 'string' && data.trim()) {
        const trimmed = data.trim();
        if (/cannot\s+(get|post|patch|put|delete)/i.test(trimmed)) {
            return fallback;
        }
        if (/proveedor_id does not exist/i.test(trimmed)) {
            return `La base de datos no tiene las migraciones de proveedores aplicadas. ${MIGRATION_HINT}`;
        }
        return trimmed;
    }

    if (data && typeof data === 'object') {
        const msg = data.error || data.message;
        if (typeof msg === 'string' && msg.trim()) {
            if (/proveedor_id does not exist/i.test(msg)) {
                return `La base de datos no tiene las migraciones de proveedores aplicadas. ${MIGRATION_HINT}`;
            }
            return msg.trim();
        }
    }

    if (typeof error?.message === 'string' && error.message.trim()) {
        return error.message.trim();
    }

    return fallback;
};

/** Sin respuesta HTTP: red caída, CORS o proxy no disponible. */
export const isNetworkOrOfflineError = error => !error?.response;
